<template>
  <v-container class="payment-container">
    <v-tabs fixed-tabs v-model="active" slider-color="#587e27" class="futuristic-tabs">
      <v-tab key="booking_type" class="earth-color" ripple>Booking Types</v-tab>
      <v-tab key="currency" class="earth-color" ripple>Destinations</v-tab>
      <v-tab key="pick-up-locations" class="earth-color" ripple>Pick Up Locations</v-tab>
      <v-tab key="gates" class="earth-color" ripple>Mode Of Entry</v-tab>
      <v-tab key="schools" class="earth-color" ripple>Schools</v-tab>

      <v-tab-item key="booking_type">
        <v-layout row wrap>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-card flat class="futuristic-card">
                <v-card-title class="card-header">
                  <div>
                    <h4 class="earth-color">NEW BOOKING TYPE</h4>
                    <div class="title-decoration"></div>
                  </div>
                </v-card-title>
                <v-container>
                  <v-form @submit.prevent="postBookingCategory()">
                    <v-text-field label="Name" v-model="booking_type.name" :rules="requiredRules" required class="futuristic-input"></v-text-field>
                    <v-textarea label="Description" v-model="booking_type.description" :rules="requiredRules" required class="futuristic-input"></v-textarea>
                    <v-btn :depressed="true" color="#587e27" block v-if="edit1 === false" type="submit" :loading="loading" class="futuristic-btn">Register</v-btn>
                    <v-btn :depressed="true" color="#f1c40f" block v-if="edit1 === true" type="submit" :loading="loading" class="futuristic-btn">Update</v-btn>
                  </v-form>
                </v-container>
              </v-card>
            </v-container>
          </v-flex>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-card flat class="futuristic-card">
                <v-card-title class="card-header">
                  <div>
                    <h4 class="earth-color">BOOKING TYPES</h4>
                    <div class="title-decoration"></div>
                  </div>
                </v-card-title>
                <v-container>
                  <v-data-table :headers="bookingTypeHeaders" :items="allBookingTypes" :disable-initial-sort="true" :loading="loading" no-data-text="No Booking Types available" class="futuristic-table">
                    <v-progress-linear slot="progress" color="#587e27"></v-progress-linear>
                    <template slot="items" slot-scope="props">
                      <td data-label="#">{{ props.index + 1 }}</td>
                      <td data-label="Name">{{ props.item.booking_type_name }}</td>
                      <td data-label="Description">{{ props.item.booking_type_description }}</td>
                      <td data-label="Action">
                        <v-btn :depressed="true" color="#f1c40f" small v-if="edit1 === false" @click="editBookingType(props.item)" :loading="loading" class="futuristic-btn">Edit</v-btn>
                        <v-btn :depressed="true" color="#e84118" small v-if="edit1 === true" @click="resetBookingType()" :loading="loading" class="futuristic-btn">Cancel Edit</v-btn>
                        <v-btn :depressed="true" color="#e84118" small v-if="props.index > 6" @click="deleteBookingType(props.item.booking_type_public_id)" :loading="loading" class="futuristic-btn">Remove</v-btn>
                      </td>
                    </template>
                  </v-data-table>
                </v-container>
              </v-card>
            </v-container>
          </v-flex>
        </v-layout>
      </v-tab-item>

      <v-tab-item key="currency">
        <v-layout row wrap>
          <v-flex lg5 md5 sm12 xs12>
            <v-container>
              <v-card flat class="futuristic-card">
                <v-card-title class="card-header">
                  <div>
                    <h4 class="earth-color">NEW DESTINATION</h4>
                    <div class="title-decoration"></div>
                  </div>
                </v-card-title>
                <v-container>
                  <v-form @submit.prevent="postDestination()">
                    <v-text-field label="Name" v-model="destination.name" :rules="requiredRules" required class="futuristic-input"></v-text-field>
                    <v-text-field label="Code" v-model="destination.code" :rules="requiredRules" required class="futuristic-input"></v-text-field>
                    <v-switch label="Requires Bed Night Levy (BNL)" color="primary" v-model="destination.requires_bnl" class="futuristic-switch"></v-switch>
                    <v-btn :depressed="true" color="#587e27" block v-if="edit2 === false" type="submit" :loading="loading" class="futuristic-btn">Add to Destinations</v-btn>
                    <v-btn :depressed="true" color="#f1c40f" block v-if="edit2 === true" type="submit" :loading="loading" class="futuristic-btn">Edit Destination</v-btn>
                  </v-form>
                </v-container>
              </v-card>
            </v-container>
          </v-flex>
          <v-flex lg7 md7 sm12 xs12>
            <v-container>
              <v-card flat class="futuristic-card">
                <v-card-title class="card-header">
                  <div>
                    <h4 class="earth-color">DESTINATIONS</h4>
                    <div class="title-decoration"></div>
                  </div>
                </v-card-title>
                <v-container>
                  <v-data-table :headers="destinationHeaders" :items="allDestinations" :disable-initial-sort="true" :loading="loading" no-data-text="No Destinations available" class="futuristic-table">
                    <v-progress-linear slot="progress" color="#587e27"></v-progress-linear>
                    <template slot="items" slot-scope="props">
                      <td data-label="#">{{ props.index + 1 }}</td>
                      <td data-label="Name">{{ props.item.destination_name }}</td>
                      <td data-label="Code">{{ props.item.destination_code }}</td>
                      <td data-label="BNL">
                        <v-icon small :color="props.item.requires_bnl === 1 ? '#587e27' : '#b0bec5'">
                          {{ props.item.requires_bnl === 1 ? 'check_circle' : 'cancel' }}
                        </v-icon>
                      </td>
                      <td data-label="Action">
                        <v-btn :depressed="true" color="#f1c40f" small @click="editDestination(props.item)" :loading="loading" class="futuristic-btn">Edit</v-btn>
                        <v-btn :depressed="true" color="#e84118" small @click="deleteDestination(props.item.destination_public_id)" :loading="loading" class="futuristic-btn">Disable</v-btn>
                      </td>
                    </template>
                  </v-data-table>
                </v-container>
              </v-card>
            </v-container>
          </v-flex>
        </v-layout>
      </v-tab-item>

      <v-tab-item key="pick-up-locations">
        <v-layout row wrap>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-card flat class="futuristic-card">
                <v-card-title class="card-header">
                  <div>
                    <h4 class="earth-color">NEW PICK UP LOCATION</h4>
                    <div class="title-decoration"></div>
                  </div>
                </v-card-title>
                <v-container>
                  <v-form @submit.prevent="postPickUpLocation()">
                    <v-text-field label="Name" v-model="pick_up_location.name" :rules="requiredRules" required class="futuristic-input"></v-text-field>
                    <v-btn :depressed="true" color="#587e27" block v-if="edit3 === false" type="submit" :loading="loading" class="futuristic-btn">Add to Pick Up Location</v-btn>
                    <v-btn :depressed="true" color="#f1c40f" block v-if="edit3 === true" type="submit" :loading="loading" class="futuristic-btn">Update Pick Up Location</v-btn>
                  </v-form>
                </v-container>
              </v-card>
            </v-container>
          </v-flex>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-card flat class="futuristic-card">
                <v-card-title class="card-header">
                  <div>
                    <h4 class="earth-color">PICK UP LOCATIONS</h4>
                    <div class="title-decoration"></div>
                  </div>
                </v-card-title>
                <v-container>
                  <v-data-table :headers="pickupLocationHeaders" :items="allPickUpLocations" :disable-initial-sort="true" :loading="loading" no-data-text="No Pick Up Locations available" class="futuristic-table">
                    <v-progress-linear slot="progress" color="#587e27"></v-progress-linear>
                    <template slot="items" slot-scope="props">
                      <td data-label="#">{{ props.index + 1 }}</td>
                      <td data-label="Name">{{ props.item.location_name }}</td>
                      <td data-label="Action">
                        <v-btn :depressed="true" color="#f1c40f" small @click="editPickUpLocation(props.item)" :loading="loading" class="futuristic-btn">Edit</v-btn>
                        <v-btn :depressed="true" color="#e84118" small @click="deletePickUpLocation(props.item.location_public_id)" :loading="loading" class="futuristic-btn">Disable</v-btn>
                      </td>
                    </template>
                  </v-data-table>
                </v-container>
              </v-card>
            </v-container>
          </v-flex>
        </v-layout>
      </v-tab-item>

      <v-tab-item key="gates">
        <v-layout row wrap>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-card flat class="futuristic-card">
                <v-card-title class="card-header">
                  <div>
                    <h4 class="earth-color">ADD A NEW MODE</h4>
                    <div class="title-decoration"></div>
                  </div>
                </v-card-title>
                <v-container>
                  <v-form @submit.prevent="postEntryMode()">
                    <v-text-field label="Name" v-model="entry_mode.name" :rules="requiredRules" required class="futuristic-input"></v-text-field>
                    <v-btn block :depressed="true" color="#587e27" v-if="edit5 === false" type="submit" :loading="loading" class="futuristic-btn">Add Entry Mode</v-btn>
                    <v-btn block :depressed="true" color="#f1c40f" v-if="edit5 === true" type="submit" :loading="loading" class="futuristic-btn">Edit Entry Mode</v-btn>
                  </v-form>
                </v-container>
              </v-card>
            </v-container>
          </v-flex>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-card flat class="futuristic-card">
                <v-card-title class="card-header">
                  <div>
                    <h4 class="earth-color">MODE OF ENTRY</h4>
                    <div class="title-decoration"></div>
                  </div>
                </v-card-title>
                <v-container>
                  <v-data-table :headers="entryModeHeaders" :items="allEntryModes" :disable-initial-sort="true" :loading="loading" no-data-text="No Entry Modes available" class="futuristic-table">
                    <v-progress-linear slot="progress" color="#587e27"></v-progress-linear>
                    <template slot="items" slot-scope="props">
                      <td data-label="#">{{ props.index + 1 }}</td>
                      <td data-label="Name">{{ props.item.entry_mode_name }}</td>
                      <td data-label="Action">
                        <v-btn :depressed="true" color="#f1c40f" small @click="editEntryMode(props.item)" :loading="loading" class="futuristic-btn">Edit</v-btn>
                        <v-btn :depressed="true" color="#e84118" small @click="deleteEntryMode(props.item.entry_mode_public_id)" :loading="loading" class="futuristic-btn">Disable</v-btn>
                      </td>
                    </template>
                  </v-data-table>
                </v-container>
              </v-card>
            </v-container>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-card flat class="futuristic-card">
                <v-card-title class="card-header">
                  <div>
                    <h4 class="earth-color">ADD A NEW GATE</h4>
                    <div class="title-decoration"></div>
                  </div>
                </v-card-title>
                <v-container>
                  <v-form @submit.prevent="postGate()">
                    <v-text-field label="Name" v-model="gates.name" :rules="requiredRules" required class="futuristic-input"></v-text-field>
                    <v-select label="Select Mode" v-model="gates.entry_mode" :items="allEntryModes" required item-text="entry_mode_name" item-value="entry_mode_public_id" :loading="loading" class="futuristic-input"></v-select>
                    <v-btn block :depressed="true" color="#587e27" v-if="edit4 === false" type="submit" :loading="loading" class="futuristic-btn">Add Gate</v-btn>
                    <v-btn block :depressed="true" color="#f1c40f" v-if="edit4 === true" type="submit" :loading="loading" class="futuristic-btn">Edit Gate</v-btn>
                  </v-form>
                </v-container>
              </v-card>
            </v-container>
          </v-flex>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-card flat class="futuristic-card">
                <v-card-title class="card-header">
                  <div>
                    <h4 class="earth-color">GATES</h4>
                    <div class="title-decoration"></div>
                  </div>
                </v-card-title>
                <v-container>
                  <v-data-table :headers="gateHeaders" :items="allGates" :disable-initial-sort="true" :loading="loading" no-data-text="No Gates available" class="futuristic-table">
                    <v-progress-linear slot="progress" color="#587e27"></v-progress-linear>
                    <template slot="items" slot-scope="props">
                      <td data-label="#">{{ props.index + 1 }}</td>
                      <td data-label="Name">{{ props.item.gate_name }}</td>
                      <td data-label="Mode">{{ props.item.entry_mode_name }}</td>
                      <td data-label="Action">
                        <v-btn :depressed="true" color="#f1c40f" small @click="editGate(props.item)" :loading="loading" class="futuristic-btn">Edit</v-btn>
                        <v-btn :depressed="true" color="#e84118" small @click="deleteGate(props.item.gate_public_id)" :loading="loading" class="futuristic-btn">Disable</v-btn>
                      </td>
                    </template>
                  </v-data-table>
                </v-container>
              </v-card>
            </v-container>
          </v-flex>
        </v-layout>
      </v-tab-item>

      <v-tab-item key="schools">
        <v-layout row wrap>
          <v-flex lg4 md4 sm12 xs12>
            <v-container>
              <v-card flat class="futuristic-card">
                <v-card-title class="card-header">
                  <div>
                    <h4 class="earth-color">{{ editSchool ? 'EDIT SCHOOL' : 'ADD A SCHOOL' }}</h4>
                    <div class="title-decoration"></div>
                  </div>
                </v-card-title>
                <v-container>
                  <v-form @submit.prevent="editSchool ? updateSchool() : addSchool()">
                    <v-text-field label="School Name" v-model="school.school_name" :rules="requiredRules" required class="futuristic-input"></v-text-field>
                    <v-select label="Level" v-model="school.level" :items="schoolLevels" :rules="[(v) => !!v || 'Item is required']" required class="futuristic-input"></v-select>
                    <v-select label="Type" v-model="school.type" :items="schoolTypes" :rules="[(v) => !!v || 'Item is required']" required class="futuristic-input"></v-select>
                    <v-select label="School Gender" v-model="school.gender" :items="allGender" :rules="[(v) => !!v || 'Item is required']" required item-text="name" item-value="public_id" :loading="loading" class="futuristic-input"></v-select>
                    <v-text-field label="City Town" v-model="school.city_town" :rules="requiredRules" required class="futuristic-input"></v-text-field>
                    <v-text-field label="KRA PIN" v-model="school.kra_pin" :rules="kraPinRules" class="futuristic-input" hint="Enter KRA PIN (e.g., A001234567B)" persistent-hint></v-text-field>
                    <v-btn :depressed="true" block :color="editSchool ? '#f1c40f' : '#587e27'" type="submit" :loading="loading" class="futuristic-btn">{{ editSchool ? 'UPDATE' : 'ADD' }}</v-btn>
                    <v-btn v-if="editSchool" :depressed="true" block color="#e84118" @click="cancelEditSchool()" class="futuristic-btn">CANCEL EDIT</v-btn>
                  </v-form>
                </v-container>
              </v-card>
            </v-container>
          </v-flex>
          <v-flex lg8 md8 sm12 xs12>
            <v-card flat class="futuristic-card">
              <v-card-title class="card-header">
                <div>
                  <h4 class="earth-color">SCHOOLS</h4>
                  <div class="title-decoration"></div>
                </div>
                <v-spacer></v-spacer>
                <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search" class="futuristic-search"></v-text-field>
              </v-card-title>
              <v-data-table :headers="columns" :items="$allSchools" :search="search" :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]" :disable-initial-sort="true" :loading="loading" no-data-text="No Schools available" class="futuristic-table">
                <v-progress-linear slot="progress" color="#587e27"></v-progress-linear>
                <template slot="items" slot-scope="props">
                  <td data-label="Code">{{ props.item.school_code }}</td>
                  <td data-label="Name">{{ props.item.school_name }}</td>
                  <td data-label="Level">{{ props.item.school_level }}</td>
                  <td data-label="Type">{{ props.item.school_type }}</td>
                  <td data-label="City/Town">{{ props.item.closest_city_town }}</td>
                  <td data-label="KRA PIN">{{ props.item.kra_pin || 'N/A' }}</td>
                  <td data-label="Action">
                    <v-btn :depressed="true" color="#f1c40f" small @click="editSchoolData(props.item)" :loading="loading" class="futuristic-btn">Edit</v-btn>
                    <v-btn :depressed="true" color="#e84118" small @click="deleteSchool(props.item.school_public_id)" :loading="loading" class="futuristic-btn">Delete</v-btn>
                  </td>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning" class="futuristic-alert">
                  Your search for "{{ search }}" found no results.
                </v-alert>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-layout>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
const SESSION_KEY = 'lkjhgfdsa';

function getSessionId() {
  return localStorage.getItem(SESSION_KEY);
}

export default {
  data() {
    return {
      active: null,
      search: '',

      edit1: false,
      edit2: false,
      edit3: false,
      edit4: false,
      edit5: false,
      editSchool: false,

      requiredRules: [
        (v) => !!v || 'This field is required',
      ],

      kraPinRules: [
        (v) => !v || /^[A-Z]\d{9}[A-Z]$/.test(v) || 'KRA PIN must be in format: A012345678B (1 letter, 9 digits, 1 letter)',
      ],

      schoolLevels: ['Nursery', 'Primary', 'Secondary', 'College', 'University'],
      schoolTypes: ['Boarding', 'Day School', 'Day & Boarding', 'Others'],

      bookingTypeHeaders: [
        { text: '#', value: 'index' },
        { text: 'Name', value: 'booking_type_name' },
        { text: 'Description', value: 'booking_type_description' },
        { text: 'Action', value: '' },
      ],

      destinationHeaders: [
        { text: '#', value: 'index' },
        { text: 'Name', value: 'destination_name' },
        { text: 'Code', value: 'destination_code' },
        { text: 'BNL', value: '' },
        { text: 'Action', value: '' },
      ],

      pickupLocationHeaders: [
        { text: '#', value: 'index' },
        { text: 'Name', value: 'location_name' },
        { text: 'Action', value: '' },
      ],

      entryModeHeaders: [
        { text: '#', value: 'index' },
        { text: 'Name', value: 'entry_mode_name' },
        { text: 'Action', value: '' },
      ],

      gateHeaders: [
        { text: '#', value: 'index' },
        { text: 'Name', value: 'gate_name' },
        { text: 'Mode', value: 'entry_mode_name' },
        { text: 'Action', value: '' },
      ],

      columns: [
        { text: 'Code', value: 'school_code' },
        { text: 'Name', value: 'school_name' },
        { text: 'Level', value: 'school_level' },
        { text: 'Type', value: 'school_type' },
        { text: 'City/Town', value: 'closest_city_town' },
        { text: 'KRA PIN', value: 'kra_pin' },
        { text: 'Action', value: '' },
      ],

      booking_type: {
        name: '',
        description: '',
        type_id: '',
        session_id: getSessionId(),
      },

      destination: {
        name: '',
        code: '',
        requires_bnl: false,
        destination_id: '',
        session_id: getSessionId(),
      },

      pick_up_location: {
        name: '',
        location_id: '',
        session_id: getSessionId(),
      },

      gates: {
        name: '',
        entry_mode: '',
        gate_public_id: '',
        session_id: getSessionId(),
      },

      entry_mode: {
        name: '',
        entry_mode_public_id: '',
        session_id: getSessionId(),
      },

      school: {
        school_name: '',
        level: '',
        type: '',
        gender: '',
        city_town: '',
        kra_pin: '',
        school_public_id: '',
        school_id: '',
        session_id: getSessionId(),
      },
    };
  },

  created() {
    this.$store.dispatch('get_all_entry_modes');
    this.$store.dispatch('get_all_booking_types');
    this.$store.dispatch('get_all_destinations');
    this.$store.dispatch('get_all_pick_up_locations');
    this.$store.dispatch('get_all_gates');
    this.$store.dispatch('fetch_all_schools');
    this.$store.dispatch('get_all_genders2');
  },

  computed: {
    loading() {
      return this.$store.state.LoadingStore.loading;
    },
  },

  methods: {
    postBookingCategory() {
      this.$store.dispatch('loading_true');
      const action = this.edit1 ? 'update_booking_type' : 'post_booking_type';
      this.$store.dispatch(action, this.booking_type).then(this.resetBookingType);
    },

    editBookingType(item) {
      this.edit1 = true;
      this.booking_type.name = item.booking_type_name;
      this.booking_type.description = item.booking_type_description;
      this.booking_type.type_id = item.booking_type_public_id;
    },

    resetBookingType() {
      this.edit1 = false;
      this.booking_type.name = '';
      this.booking_type.description = '';
      this.booking_type.type_id = '';
    },

    deleteBookingType(publicId) {
      this.$store.dispatch('loading_true');
      this.$store.dispatch('delete_booking_type', {
        type_id: publicId,
        session_id: getSessionId(),
      });
    },

    postDestination() {
      this.$store.dispatch('loading_true');
      const payload = {
        ...this.destination,
        requires_bnl: this.destination.requires_bnl ? 1 : 0,
      };
      const action = this.edit2 ? 'update_destination' : 'post_destination';
      this.$store.dispatch(action, payload).then(this.resetDestination);
    },

    editDestination(item) {
      this.edit2 = true;
      this.destination.name = item.destination_name;
      this.destination.code = item.destination_code;
      this.destination.requires_bnl = item.requires_bnl === 1;
      this.destination.destination_id = item.destination_public_id;
    },

    resetDestination() {
      this.edit2 = false;
      this.destination.name = '';
      this.destination.code = '';
      this.destination.requires_bnl = false;
    },

    deleteDestination(publicId) {
      this.$store.dispatch('loading_true');
      this.$store.dispatch('delete_destination', {
        destination_id: publicId,
        session_id: getSessionId(),
      });
    },

    postPickUpLocation() {
      this.$store.dispatch('loading_true');
      const action = this.edit3 ? 'update_pickuplocation' : 'post_pickuplocation';
      this.$store.dispatch(action, this.pick_up_location).then(this.resetPickUpLocation);
    },

    editPickUpLocation(item) {
      this.edit3 = true;
      this.pick_up_location.name = item.location_name;
      this.pick_up_location.location_id = item.location_public_id;
    },

    resetPickUpLocation() {
      this.edit3 = false;
      this.pick_up_location.name = '';
      this.pick_up_location.location_id = '';
    },

    deletePickUpLocation(publicId) {
      this.$store.dispatch('loading_true');
      this.$store.dispatch('delete_pickuplocation', {
        location_id: publicId,
        session_id: getSessionId(),
      });
    },

    postGate() {
      const action = this.edit4 ? 'update_gate' : 'post_gate';
      this.$store.dispatch(action, this.gates).then(this.resetGate);
    },

    editGate(item) {
      this.edit4 = true;
      this.gates.name = item.gate_name;
      this.gates.gate_public_id = item.gate_public_id;
      this.gates.entry_mode = item.entry_mode_public_id;
    },

    resetGate() {
      this.edit4 = false;
      this.gates.name = '';
      this.gates.entry_mode = '';
      this.gates.gate_public_id = '';
    },

    deleteGate(publicId) {
      this.$store.dispatch('delete_gate', {
        gate_id: publicId,
        session_id: getSessionId(),
      });
    },

    postEntryMode() {
      const action = this.edit5 ? 'update_entry_mode' : 'post_entry_mode';
      this.$store.dispatch(action, this.entry_mode).then(this.resetEntryMode);
    },

    editEntryMode(item) {
      this.edit5 = true;
      this.entry_mode.name = item.entry_mode_name;
      this.entry_mode.entry_mode_public_id = item.entry_mode_public_id;
    },

    resetEntryMode() {
      this.edit5 = false;
      this.entry_mode.name = '';
      this.entry_mode.entry_mode_public_id = '';
    },

    deleteEntryMode(publicId) {
      this.$store.dispatch('delete_entry_mode', {
        entry_mode_public_id: publicId,
        session_id: getSessionId(),
      });
    },

    addSchool() {
      this.$store.dispatch('loading_true');
      this.$store.dispatch('post_new_school', this.school).then(this.resetSchoolForm);
    },

    editSchoolData(item) {
      this.editSchool = true;
      this.school.school_name = item.school_name;
      this.school.level = item.school_level;
      this.school.type = item.school_type;
      this.school.gender = item.school_gender;
      this.school.city_town = item.closest_city_town;
      this.school.kra_pin = item.kra_pin || '';
      this.school.school_public_id = item.school_public_id;
      this.school.school_id = item.school_public_id;
    },

    updateSchool() {
      this.$store.dispatch('loading_true');
      this.$store.dispatch('update_school', {
        school_id: this.school.school_id,
        school_name: this.school.school_name,
        level: this.school.level,
        type: this.school.type,
        gender: this.school.gender,
        city_town: this.school.city_town,
        kra_pin: this.school.kra_pin,
        session_id: this.school.session_id,
      }).then(this.resetSchoolForm);
    },

    cancelEditSchool() {
      this.editSchool = false;
      this.resetSchoolForm();
    },

    resetSchoolForm() {
      this.editSchool = false;
      this.school.school_name = '';
      this.school.level = '';
      this.school.type = '';
      this.school.gender = '';
      this.school.city_town = '';
      this.school.kra_pin = '';
      this.school.school_public_id = '';
      this.school.school_id = '';
    },

    deleteSchool(publicId) {
      if (!confirm('Are you sure you want to delete this school?')) return;
      this.$store.dispatch('delete_school', {
        session_id: getSessionId(),
        school_id: publicId,
      });
    },
  },
};
</script>

<style scoped>
  .payment-container { background: #ffffff; border-radius: 8px; padding: 16px; transition: all 0.3s ease; }
  .payment-container:hover { box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1); }
  .card-header { background: linear-gradient(45deg, #e8eaf6, #f5f7fa); padding: 16px; border-radius: 8px; }
  .earth-color { color: #587e27; font-weight: 600; margin: 0; font-size: 1.5rem; }
  .title-decoration { height: 4px; background: linear-gradient(90deg, #587e27, transparent); margin-bottom: 16px; width: 100px; }
  .futuristic-card { border-radius: 8px; background: #ffffff; transition: all 0.3s ease; }
  .futuristic-card:hover { box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1); }

  .futuristic-input >>> .v-input__slot { border-radius: 8px; background: #f5f7fa; }
  .futuristic-switch >>> .v-input--switch__thumb { background: #587e27; }
  .futuristic-switch >>> .v-input--switch__track { background: #e8eaf6; }

  .futuristic-btn { border-radius: 8px; text-transform: none; font-weight: 500; transition: all 0.2s ease; }
  .futuristic-btn:hover { transform: translateY(-1px); box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); }

  .futuristic-table { border-radius: 8px; background: #ffffff; }
  .futuristic-table >>> th { color: #587e27; font-weight: 600; }

  .futuristic-link { color: #587e27; text-decoration: none; transition: color 0.2s ease; }
  .futuristic-link:hover { color: #1b5e20; }

  .futuristic-alert { border-radius: 8px; background: #fff5f5; }
  .futuristic-search >>> .v-input__slot { border-radius: 8px; background: #f5f7fa; }

  .futuristic-tabs >>> .v-tabs__bar { background: #ffffff; border-radius: 8px; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); }
  .futuristic-tabs >>> .v-tabs__item { color: #587e27; font-weight: 500; text-transform: none; transition: all 0.2s ease; }
  .futuristic-tabs >>> .v-tabs__item:hover { background: #f5f7fa; }
  .futuristic-tabs >>> .v-tabs__slider { background: #587e27; }

  @media (max-width: 960px) { .payment-container { padding: 12px; } .card-header { padding: 12px; } .earth-color { font-size: 1.25rem; } .futuristic-btn { font-size: 0.9rem; } }
  @media (max-width: 600px) { .payment-container { padding: 8px; border-radius: 6px; } .card-header { padding: 8px; } .earth-color { font-size: 1.1rem; } .futuristic-btn { font-size: 0.85rem; } }
</style>